<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-6">
                        <div class="font-weight-bold body-1">
                            Llenar encuesta manual
                        </div>
                    </v-col>
                </v-row>

                

                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <v-form ref="form" @submit.prevent="save">
                            <SurveyEmployeeSelectionForm  ref="SurveyEmployeeSelectionForm" :values="form" @save="save" :serverErrors="serverErrors" :surveyId="id"></SurveyEmployeeSelectionForm>
                        </v-form>
                    </v-col>

                </v-row>

            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import SurveyEmployeeSelectionForm from "./SurveyEmployeeSelectionForm.vue";
// import Utils from '../../../../helpers/Utils';
export default {
    components: {
        'SurveyEmployeeSelectionForm': SurveyEmployeeSelectionForm,
    },

	data(){
		return {
            id: this.$route.params.id,
            serverErrors: {},
            loading: false,
            form: {
                company_id: '',
                employeeId: '',

            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Questionary",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Continuar",
                icon: "mdi-arrow-right",
                click: this.save,
                block:false,
                loading: false,
            },
            
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
    },
    watch: {
      
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        
		validate () 
        {
			return this.$refs.form.validate()
		},

       
        save(){
            // this.$router.push({ name: 'surveyQuestion', params: { surveyId: this.id, employeeId: this.form.employeeId } });
			// this.$store.state.layout = 'Questionnaire';
			let routeData = this.$router.resolve({
				path: `/encuestas/${this.id}/${this.form.employeeId}`,
				query: {
				}
			});
			//* open survey
			window.open(routeData.href, '_blank', "popup");
            // eslint-disable-next-line no-console
        },

        
        processRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));

            return data;
        }
    },
}
</script>

<style lang="scss">
    
</style>